// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wr-0";
export var confirmationIcon = "_wr-1";